/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const CONTEXT_LEARNING_INFO = gql`
  fragment ContextualLearningInfoFragment on ContextualLearningInfo {
    id
    isDeleted
    requestId
    contextFactsInfo {
      id
      names
      locations
      dereferencedId
      type
      value
    }
  }
`;
